module.exports = __webpack_public_path__ + "img/get-coins.f5b13e9c.svg";